<template>
  <v-container>
    <v-data-table
      v-if="item[0].move"
      :headers="headersMove"
      :items="item"
      item-key="name"
      class="elevation-0 pa-10"
      hide-default-footer
    >
      <template v-slot:[`item.sourcePrefix`]="{ item }">
        <div
          class="text-truncate"
          style="max-width: 200px"
          :title="item.sourcePrefix"
        >{{ item.sourcePrefix }}</div>
      </template>
      <template v-slot:[`item.targetPrefix`]="{ item }">
        <div
          class="text-truncate"
          style="max-width: 200px"
          :title="item.targetPrefix"
        >{{ item.targetPrefix }}</div>
      </template>
      <template v-slot:no-data>
        <span color="primary">No data to show you</span>
      </template>
    </v-data-table>
    
    <v-data-table
      v-else
      :headers="headersCopy"
      :items="item"
      item-key="name"
      class="elevation-0 pa-10"
      hide-default-footer
    >
      <template v-slot:[`item.deliveredTo`]="{ item }">
        <div
          class="text-truncate"
          style="max-width: 200px"
          :title="item.deliveredTo"
        >{{ getCompanyName(item.deliveredTo) }}</div>
      </template>
      <template v-slot:[`item.sourcePrefix`]="{ item }">
        <div
          class="text-truncate"
          style="max-width: 200px"
          :title="item.sourcePrefix"
        >{{ item.sourcePrefix }}</div>
      </template>
      <template v-slot:[`item.expiresAt`]="{ item }">
        {{ new Date(item.expiresAt).toLocaleString() }}
      </template>
      <template v-slot:no-data>
        <span color="primary">No data to show you</span>
      </template>
    </v-data-table>
  </v-container>
</template>
<script>
export default {
  props:{
    item: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      headersMove: [
        { text: "Origin Bucket", value: "sourceBucket" },
        { text: "Targhet Bucket", value: "targetBucket" },
        { text: "Origin Folder", value: "sourcePrefix" },
        { text: "Targhet Folder", value: "targetPrefix"},
      ],
      headersCopy: [
        { text: "Customer", value: "deliveredTo" },
        { text: "Origin Bucket", value: "sourceBucket" },
        { text: "Origin Folder", value: "sourcePrefix" },
        { text: "Expiration Date", value: "expiresAt"},
      ]
    }
  },
  methods: {
    getCompanyName(sourcePrefix) {
      if (sourcePrefix.includes('@')) {
        let tmp = sourcePrefix.split('@');
        return tmp[tmp.length - 1];
      }
      return sourcePrefix;
    }
  },
}
</script>